import { createTheme } from '@mantine/core';

export const theme = createTheme({
  fontFamily: 'Roboto',
  cursorType: 'pointer',
  components: {
    Button: {
      styles: (theme, params) => ({
        root: {
          ...(params.size === 'sm' && {
            minHeight: '32px',
            height: '32px',
            fontSize: '14px',
            lineHeight: '20px',
            fontWeight: '400'
          })
        }
      })
    }
  }
});
